///include /assets/js/app/p/catalogue.js
///include /assets/js/app/p/disabled-pages.js
///include /assets/js/app/p/user-contact-info.js
///include /assets/js/app/p/user.js
///include /assets/js/app/p/support-articles/support-articles.js

/**
 * This is the Vue/Controller for the main navigation header
 */

"use strict"

// The following words are excluded when searching articles
var excludeWords = {
    "the": 1,
    "is":  1,
    "to":  1,
    "i":   1,
    "and": 1
}

const MainMenuCategory = Vue.extend({
    template: "#main-menu-category",
    props: {
        badge: {
            type: Object,
            required: false
        },
        href: {
            type: String,
        },
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: Object,
            required: false,
        },
        noPad: {
            type: Boolean,
            default: false
        },
        // If there is no sub-nav__list after this component then it is a "solo" element
        solo: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            disabledPages: DisabledPages.inst,
        }
    },
    computed: {
        disabled() {
            return this.disabledPages.matches(this.href)
        }
    },
    methods: {
        click() {
            this.$emit("click")
        },
    },
})

const MainMenuItem = Vue.extend({
    template: "#main-menu-item",
    props: {
        badge: {
            type: Object,
            required: false
        },
        href: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: Object,
            required: false,
        },
        src: {
            type: String,
            required: false,
        },
        target: {
            type: String,
            required: false,
        },
        img: Object
    },
    data() {
        return {
            disabledPages: DisabledPages.inst,
        }
    },
    computed: {
        disabled() {
            return this.disabledPages.matches(this.href)
        },
    },
    methods: {
        click() {
            this.$emit("click")
        },
    },
})

const MainMenuItemAction = Vue.extend({
    template: "#main-menu-item-action",
    props: {
        href: {
            type: String,
            required: false,
        },
        target: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            disabledPages: DisabledPages.inst,
        }
    },
    computed: {
        disabled() {
            return(
                this.href &&
                this.disabledPages.matches(this.href)
            )
        },
    },
    methods: {
        click() {
            this.$emit("click")
        },
    },
})

const SlidePanelItem = Vue.extend({
    template: "#slide-panel-item",
    props: {
        href: {
            type: String,
            required: true,
        },
        target: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            disabledPages: DisabledPages.inst,
        }
    },
    computed: {
        disabled() {
            return this.disabledPages.matches(this.href)
        },
    },
    methods: {
        click() {
            this.$emit("click")
        },
    },
})

const SlidePanelTopItem = Vue.extend({
    template: "#slide-panel-top-item",
    props: {
        href: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            disabledPages: DisabledPages.inst,
        }
    },
    computed: {
        disabled() {
            return(
                this.href &&
                this.disabledPages.matches(this.href)
            )
        },
    },
    methods: {
        click() {
            this.$emit("click")
        },
    },
})
/**
 * @typedef {{category_id: string, parent_id: string, category_name: string, category_image: string, category_description: string, category_group: string, category_url_title: string}} categoryIn
 */

/**
 * @typedef {{title: string, url_title: string, support_text: string, entry_id: number, categories: categoryIn[]}} supportArticleIn
 */

/**
 * @typedef {supportArticleIn & {categoryIcon: string, firstSentence: string, url: string}} supportArticle
 */

var Navigation = new Vue({
    el: "#navigation-container",
    data() {
        return {
            aiPrompt: {
                text: "",
                type: null
            },
            /** @type {BasketClient} */
            //@ts-ignore
            basketClient: AnyBasket.inst,
            basketDisabled: false,
            basketHeight: 100,
            catalogue: new Catalogue(),
            /**
             * @type {any}
             */
            debounce: null,
            help: {
                articleInView: null,
                /**
                 * @type {supportArticle[]}
                 */
                supportArticleData: [],
                topSupportSearch: null,
            },
            navTransitionStore: 'home',
            navTransitionName: 'slide-in',
            openPanel: null,
            ticketCount: 0,
            stackTicketCount: 0,
            /**
             * @type {null | { incidents: any[], maintenance: any[] }}
             */
            statusPageData: null,
            /**
             * @type {null|SupportArticles}
             */
            supportArticles: null,
            user: User.inst,
            userContactInfo: UserContactInfo.inst,
            packageCount: 0,
            managedVpsCount: 0,
            topbarNotification: {},
            displayTopbarNotification: false,
            get allItems() {
                if(!this.items) {
                    return null
                }
                var gbByMailbox = {};
                var nonMailboxUpgrades = this.items.filter( i => i.classCode != "mailbox_quota_addon-plus10" || i.isRenewal);
                var mailboxUpgrades    = this.items.filter( i => i.classCode === "mailbox_quota_addon-plus10" && !i.isRenewal );
                if( mailboxUpgrades.length > 0 ){
                    for(const mb of mailboxUpgrades){
                        if( !gbByMailbox[mb.configuration.id] ){
                            gbByMailbox[mb.configuration.id] = 10;
                        } else {
                            gbByMailbox[mb.configuration.id] += 10;
                        }
                    }
                }
                // Compress them
                var groupedItems = [];
                for(const mailId of Object.keys(gbByMailbox)){
                    var item = mailboxUpgrades.find( u => u.configuration.id == mailId );
                    var newItem = item.exportObject();
                    if( newItem ){
                        newItem.label = newItem.label.replace("10",gbByMailbox[mailId]);
                        newItem["line-price"]  = newItem['line-price'] * (gbByMailbox[mailId]/10);
                        groupedItems.push( new BasketItem(newItem) );
                    }
                }
                return nonMailboxUpgrades.concat(groupedItems).concat(this.invalidItems || []);
            },
            get avatarURL() {
                return(
                    (this.contact && this.contact.avatarUrl) ||
                    "/assets/images/icons/nav/icon-user.png"
                )
            },
            get basketLoadInProgress() {
                return this.basketClient.loadInProgress
            },
            get contact() {
                return this.userContactInfo.contact
            },
            get contactEmail() {
                return this.contact && this.contact.email
            },
            get contactName() {
                return this.contact && (
                    this.contact.company_name || this.contact.person_name
                )
            },
            get invalidItems() {
                return this.basketClient.invalidItems
            },
            get items() {
                return this.basketClient.items
            },
            get servicesOperational() {
                let operational = true

                if (!this.statusPageData) return false

                const hasIncident = this.statusPageData.incidents.some((incident) => incident.status !== 'Fixed')
                const hasMaintenance = this.statusPageData.maintenance.some((maintenace) => maintenace.status !== 'Complete')

                if (hasIncident || hasMaintenance) {
                    operational = false
                }

                return operational
            },
            get upcomingMaintenance() {
                return this.statusPageData?.maintenance.some((maintenace) => maintenace.status !== 'Complete')
            },
            get topSupportArticles() {
                if(!this.supportArticles) return null
                /**
                 * @type {supportArticle[]}
                 */
                if(this.help.topSupportSearch) {
                    return this.supportArticles.findAndReturn(this.help.topSupportSearch)
                } else if($(".onpageHelpInitialSearch").length && this.help.topSupportSearch === null) {
                    var dsv = $(".onpageHelpInitialSearch")[0].value;
                    if( dsv.match(/\[/) ){
                        let defaultTopFive = JSON.parse( dsv );
                        return this.supportArticles.findAndReturnByIds(defaultTopFive)
                    } else {
                        this.help.topSupportSearch = dsv;
                    }
                } else {
                    const articles = this.supportArticles.articles.slice()
                    return articles.sort((a, b) => b.impressions - a.impressions).slice(0, 5)
                }
            },
            get userPrefs() {
                if( this.user && this.user.preferences ){
                    return this.user.preferences;
                } else {
                    return {};
                }
            },
            get validItemCount() {
                return this.items && this.items.length
            },
            get visibleItemCount() {
                return this.allItems && this.allItems.length
            },

            get agencyHubEnabled() {
                return this.user && this.user.hasAgencyHub;
            },

            set agencyHubEnabled(v) {
                if( this.user ){
                    $.ajax({
                        url: `/a/setAgencyHubState`,
                        method: 'post',
                        data: {
                            state: (v ? 'enabled' : 'disabled')
                        }
                    }).then( (r) => {
                        sessionStorage.removeItem("hasAgencyHub");
                        this.user.reload(['hasAgencyHub']);
                    } );
                }
            },

            /** Routes the browser to the checkout page */
            goToCheckout() {
                this.basketClient.goToCheckout()
            },

            signOut() {
                delete sessionStorage['contact'];
                location.href = "/logout"
            },
        }
    },

    computed: {
        navTransitionPage: {
            get() {
                return this.navTransitionStore
            },
            set(value) {
                if (value === 'home') {
                    this.navTransitionName = 'slide-right'
                } else {
                    this.navTransitionName = 'slide-left'
                }

                this.$nextTick(() => {
                    this.navTransitionStore = value

                })

            }
        },
        inverseNavTransitionName() {
            return this.navTransitionName === 'slide-left' ? 'slide-right' : 'slide-left'
        }
    },

    methods: {
        goToDomainPage() {
            return window.location.href = "/domain-search";
        },
        storeSearch() {
            clearTimeout(this.debounce)
            this.debounce = null
            if(this.help.topSupportSearch && this.help.topSupportSearch !== "") {
                this.debounce = setTimeout(() => {
                    if(this.supportArticles) {
                        this.supportArticles.searchStoreQuery(this.help.topSupportSearch)
                    }
                }, 2000)
            }
        },

        closeTopbarNotification() {
            this.topbarNotificationLog(this.topbarNotification.id, "close")
            this.displayTopbarNotification = false
        },

        topbarNotificationLog(id, type) {
            $.ajax({
                method: "POST",
                url: `/a/pop-up-notification/analytics/${id}`,
                data: {
                    type
                },
            }).then(r => {})
        },

        toggleChat() {
            document.getElementById('ai-chat-button').click();
            $('.nav-support__content').css('pointer-events', 'none');
            setTimeout(function() {
                $('.nav-support__content').css('pointer-events', 'auto');
            }, 500);
        }
    },

    watch: {
        items(v) {
            this.$nextTick(() => {
                const h = $(".mini-basket.basket-vue-container").height()
                if(h) this.basketHeight = h
            })
        },
        async openPanel(v) {
            switch(v) {
                case "basket":
                    const basket_enabled =
                        await User.inst.checkScopes("buy")
                    this.basketDisabled = !basket_enabled
                    if(basket_enabled) {
                        this.basketClient.reloadContent()
                    }
                    break
                default:
            }
        }
    },
    components: {
        mainMenuCategory: MainMenuCategory,
        mainMenuItem: MainMenuItem,
        mainMenuItemAction: MainMenuItemAction,
        slidePanelItem: SlidePanelItem,
        slidePanelTopItem: SlidePanelTopItem,
        themeToggler: themeTOGGLER,
        ai: AI,
    },
    async mounted() {
        this.statusPageData = await $.ajax("https://www.stackstatus.com/api/incidents")

        this.stackTicketCount = await NPSUtil.collectionLength(
            `/a/stack_ticket/ticket`
        )

        const basket_enabled = await User.inst.checkScopes("buy")
        this.basketDisabled = !basket_enabled
        if(basket_enabled) {
            try {
                await this.basketClient.reloadContent()
            } catch(jqXHR) {
                ShowNotification.warn(
                    "There was a problem fetching basket contents, please contact support."
                )
            }
        }

        const hasReseller = await User.inst.networkPropertyHandlers.hasReseller()
        this.supportArticles = typeof SupportArticles != "undefined" ?
            new SupportArticles(hasReseller !== null ? hasReseller : false) :
            null

        this.packageCount = parseInt(await $.ajax({
            url: `/a/package`,
            method: 'head'
        }).then((a, b, c) => c.getResponseHeader("X-Collection-Length")))

        this.managedVpsCount = parseInt(await $.ajax({
            url: `/a/managed_vps`,
            method: 'head'
        }).then((a, b, c) => c.getResponseHeader("X-Collection-Length")))

        await $.ajax({
            url: `/a/pop-up-notifications`,
            data: {
                type: "topbar",
                page: window.location.pathname,
                publishNow: true
            },
        }).done(r => {
            if(r){
                this.topbarNotification = r;
                const contentUk = this.topbarNotification?.contentUk ? this.topbarNotification.contentUk.replace("{{ first_name }}", this.contact.person_name.split(" ")[0]) : ""
                const contentUs = this.topbarNotification?.contentUs ? this.topbarNotification.contentUs.replace("{{ first_name }}", this.contact.person_name.split(" ")[0]) : ""
                if(this.basketClient.content.currency == "GBP"){
                    this.topbarNotification.content = contentUk
                } else {
                    this.topbarNotification.content = contentUs ? contentUs : contentUk
                }
                this.displayTopbarNotification = true
            }
        })
    }
})
